import { connectHits } from 'react-instantsearch-dom';
import SiteLink from 'components/shared/sitelink';
import { useRouter } from 'next/router';
import useSearchContentTracking from 'hooks/tracking/useSearchContentTracking';
import { addLocaleToHref } from 'lib/utils/helpers';
import styles from './pageHits.module.scss';

const PageHits = ({ locale, hits, noSearchDone, hasResults, searchQuery, resources }) => {
  const { informationTitle, noInformation } = resources[3];
  const router = useRouter();

  const trackSearchResultClick = slug =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useSearchContentTracking({
      searchQuery,
      searchResult: {
        type: 'page',
        slug,
      },
      location: { action: router },
    });

  const otherPages = hits
    .filter(
      hit =>
        hit.sectionsCollection.length > 0 &&
        hit.sectionsCollection.some(
          // eslint-disable-next-line no-underscore-dangle
          section => section.__typename !== 'SectionBlogArticle' && section.title
        )
    )
    .map(hit => {
      const firstTitle = hit.sectionsCollection.find(section => section.title);
      const seoTitle = hit.seo?.title;
      return {
        slug: hit.slug,
        title: seoTitle || firstTitle.title,
      };
    });
  const maximumOtherPages =
    otherPages.length >= 4 ? otherPages.slice(0, 4) : otherPages.slice(0, otherPages.length);

  return (
    <div className={styles.pageHitsWrapper}>
      {!noSearchDone && (
        <>
          <h2 className={styles.pageHitsName}>{informationTitle.text}</h2>
          {maximumOtherPages.length === 0 && (
            <p className={styles.noInformationText}>{noInformation.text}</p>
          )}
          {hasResults &&
            maximumOtherPages.map(
              page =>
                page.slug && (
                  <SiteLink
                    locale={locale}
                    key={page.slug}
                    className={styles.pageHit}
                    href={addLocaleToHref(page.slug, locale, router)}
                    onClick={() => trackSearchResultClick(page.slug)}
                  >
                    <h3 className={styles.pageHitsTitle}>{page.title}</h3>
                  </SiteLink>
                )
            )}
        </>
      )}
    </div>
  );
};

const CustomPageHits = connectHits(PageHits);

export default CustomPageHits;
